module.exports = __webpack_public_path__ + "img/img1.e3e21ca3.jpeg";